import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=d755907a&scoped=true"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"
import style0 from "./medical.vue?vue&type=style&index=0&id=d755907a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d755907a",
  null
  
)

export default component.exports